import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuthContext } from './context';
import { LoadingScreen, SessionErrorScreen } from './StatusScreens';

/** Elemento de rota "layout": só deixa passar (`<Outlet />`) quem está conectado. */
export function RequireAuth() {
  const { state, endReason } = useAuthContext();
  const { pathname, search, hash } = useLocation();

  switch (state.status) {
    case 'loading':
      return <LoadingScreen />;
    case 'error':
      return <SessionErrorScreen error={state.error} onRetry={state.retry} />;
    case 'unauthenticated':
      // Depois de um logout explícito não se guarda o destino: o próximo login começa em "/",
      // nunca na página que estava aberta. Link direto e sessão expirada voltam ao lugar.
      return endReason === 'logout' ? (
        <Navigate to="/login" replace />
      ) : (
        <Navigate to="/login" replace state={{ from: { pathname, search, hash } }} />
      );
    case 'authenticated':
      return <Outlet />;
  }
}
